import { Component } from 'react';
import type { ReactNode } from 'react';
import { i18next } from '@/i18n';

export class ErrorBoundary extends Component<{ children: ReactNode; resetKey?: string }, { failed: boolean }> {
  override state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  override componentDidUpdate(previous: Readonly<{ children: ReactNode; resetKey?: string }>) {
    if (this.state.failed && previous.resetKey !== this.props.resetKey) this.setState({ failed: false });
  }
  override render() {
    if (!this.state.failed) return this.props.children;
    // Do not log errors: an exception thrown by a feature can contain private response data.
    return <div className="shell-empty" role="alert">
      <h2>{i18next.t('shell:errorTitle')}</h2>
      <p>{i18next.t('shell:errorMessage')}</p>
      <button className="shell-primary" onClick={() => this.setState({ failed: false })}>{i18next.t('shell:retry')}</button>
    </div>;
  }
}
